<style scoped>

@page {
  size: 4in 2in;
  background-color: #00acc1;
}

@media print {
  @page {
  }
}

.box {
  border: 2px solid black;
  height: 30px;
  width: 30px;
  padding: 0;
  font-size: large;
}

.circle-smaller {
  padding: 0;
  border: 3px dashed black;
  height: 40px;
  border-radius: 50%;
  width: 50px;
  font-size: 20px;
  line-height: 25px;
}

.circle {
  padding: 0;
  border: 4px solid black;
  height: 70px;
  border-radius: 50%;
  width: 70px;
  font-size: 50px;
  line-height: 60px;
  font-weight: bolder;
}


/* border: 1px solid black; */

/**
  the page width is set to avoid clipping on left/right
  the page height is set to avoid blanks on the next page
 */
.component-label {
  width: 3.7in !important;
  height: 1.85in !important;
  color: black;
  overflow: clip;
  overflow-clip-margin: content-box;
}

.page-break {
  page-break-after: always;
}

.circle {
  text-align: center;
  padding: 0;
  margin: 5px;
  border: 3px solid black;
  height: 70px;
  border-radius: 50%;
  min-width: 75px;
  font-size: 20px;
  line-height: 65px;
  font-weight: bolder;
}
</style>
<template>
  <v-container class="component-label pa-0 ">
    <v-row dense align-content="center" justify="center">
      <v-col cols="3" class="ma-0 pb-0" align-self="start">
        <div class="d-flex flex-column">
          <img
            :src="qrCodeDataURL" :style="`width:${qrCodeSize}px; height:${qrCodeSize}px;`"
            style="position:relative; top:-10px; left:-10px;"
          />
          <div class=""
               style=" line-height: 18px;"
          >
            <!--            style="position:relative; top:-12px; left:10px; line-height: 10px;"-->
            <!--            :style="`height: ${1400-qrCodeSize}`"-->
            <v-row dense v-for="(portion,i) of portionSizes" v-bind:key="i"
                   style="font-family: 'monospace'"
                   class="px-0 mx-0 "
            >
              <v-col cols="6"
                     :class="j!==0?'text-left pl-2':'text-right'"
                     v-for="(part,j) of portion.split(' ')" v-bind:key="`${i}${j}`">
                {{ part }}
              </v-col>
            </v-row>
          </div>
        </div>
      </v-col>
      <v-col cols="6" class="ma-0 py-0 text-center space-between" align-self="center"
             style="align-content: space-between">
        <div style="font-size: xx-large; line-height: 30px">{{ formatWeightWithUnits(amount) }}</div>
        <span style="font-size:x-small">{{ date }}</span>
        <span style="font-size:x-small; text-transform: uppercase; font-weight: bolder">
        | {{ production }}
        </span>
<!--        <template v-if="priority">-->
<!--          <span style="font-size:x-small;  font-weight: bolder">| {{ priority }}</span>-->
<!--        </template>-->
        <div class="py-1"
             style="overflow: hidden; overflow-wrap: break-word; max-height: 45px; font-size: 12px; line-height: 12px">
          {{ text }}
        </div>
        <div class="" style="font-size: 22px">
          <span style="text-transform:uppercase; text-decoration: underline">{{ rack }}</span>
          <span style="">
            {{ title }}
          </span>
        </div>
      </v-col>
      <v-col cols="3" align-self="center" class="ma-0 pb-0 text-center" style="overflow:clip;">
        <div class="text-center" style="">
          {{ portionString }}
        </div>
        <div class="circle" style="font-size: large" v-if="batch">{{ batch }}</div>
        <div class="row">
          <div class="col">
            <div v-if="lineShape==='square'">
              <span class="px-2 box" v-if="line">{{ line }}</span>
            </div>
            <div class="text-center" v-else>
              <span class="circle-smaller" v-if="line">{{ line }}</span>
            </div>
          </div>
          <div class="col-auto text-right" style="font-size: larger; font-weight: bold">{{ priority }}</div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
import QRCode from "qrcode";
import {formatWeightWithUnits} from "../store/utils";

export default {
  name: "ComponentLabel",
  methods: {formatWeightWithUnits},
  props: {
    code: {type: String, required: true},
    text: {type: String, required: true},
    batch: {type: String, required: true},
    amount: {type: Number, required: true},
    priority: {type: String, required: false},
    production: {type: String, default: ''},
    production_priority: {required: false},
    line: {type: String, default: '', required: false},
    title: {type: String, required: true},
    date: {type: String, default: null, required: false},
    lineShape: {type: String, default: null, required: false},
    rack: {type: String, default: null, required: false},
    portionCount: {default: null, required: false},
    portionSize: {default: null, required: false},
    component: {default: null, required: true},
  },
  async mounted() {
    this.qrCodeDataURL = await QRCode.toDataURL(this.qrCodeData, {
      type: 'svg',
      width: this.qrCodeSize,
      height: this.qrCodeSize
    });
  },
  data() {
    return {
      qrCodeSize: 100,
      qrCodeDataURL: null
    }
  },
  computed: {
    portionSizes() {
      const ratio = {
        small: this.component.small_ratio,
        medium: 1,
        large: this.component.large_ratio,
      }
      return Object.keys(ratio)
        .filter(size => this.portionCount[size] > 0)
        .map(size =>
          `${formatWeightWithUnits(Math.round(this.portionSize * ratio[size]))} `
          + (`${size.slice(0, 1).toUpperCase()}${this.portionCount[size]}`)
        );
    },
    portionString() {
      if (this.portionCount) {
        return `${Object.values(this.portionCount).reduce((sum, i) => sum + i, 0)}CT`;
      } else {
        return '';
      }
    },
    qrCodeData() {
      return `${this.batch}:${this.line || 'M'}:${this.code}`;
    }
  }
}
</script>


